import { render, staticRenderFns } from "./relationModal.vue?vue&type=template&id=e3a9020c&scoped=true&"
import script from "./relationModal.vue?vue&type=script&lang=js&"
export * from "./relationModal.vue?vue&type=script&lang=js&"
import style0 from "./relationModal.vue?vue&type=style&index=0&id=e3a9020c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a9020c",
  null
  
)

export default component.exports